/**
 * BackendConnectionHttpTag automatically generated by SDKgen please do not edit this file manually
 * {@link https://sdkgen.app}
 */

import {TagAbstract, HttpRequest} from "sdkgen-client"
import {ClientException, UnknownStatusCodeException} from "sdkgen-client";

import {BackendHttpRequest} from "./BackendHttpRequest";
import {BackendHttpResponse} from "./BackendHttpResponse";
import {CommonMessage} from "./CommonMessage";
import {CommonMessageException} from "./CommonMessageException";

export class BackendConnectionHttpTag extends TagAbstract {
    /**
     * Sends an arbitrary HTTP request to the connection
     *
     * @returns {Promise<BackendHttpResponse>}
     * @throws {CommonMessageException}
     * @throws {ClientException}
     */
    public async execute(connectionId: string, payload: BackendHttpRequest): Promise<BackendHttpResponse> {
        const url = this.parser.url('/backend/connection/:connection_id/http', {
            'connection_id': connectionId,
        });

        let request: HttpRequest = {
            url: url,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            params: this.parser.query({
            }, [
            ]),
            data: payload
        };

        const response = await this.httpClient.request(request);
        if (response.ok) {
            return await response.json() as BackendHttpResponse;
        }

        const statusCode = response.status;
        if (statusCode >= 0 && statusCode <= 999) {
            throw new CommonMessageException(await response.json() as CommonMessage);
        }

        throw new UnknownStatusCodeException('The server returned an unknown status code: ' + statusCode);
    }



}
